import {button,escapeHtml} from '../ui/components.js';

function backAction(){
  return button({id:'smokehouse-back-dashboard',label:'Wróć do Mojej wędzarni',variant:'ghost'});
}

function emptyCopy(text){
  return '<p class="smokehouse-empty">'+escapeHtml(text)+'</p>';
}

function smokerRows(model){
  const items=model?.smokers?.items||[];
  if(!items.length)return emptyCopy('Nie masz jeszcze dodanej wędzarni.');
  return '<div class="manage-list">'+items.map(item=>
    '<article class="manage-row"><div><strong>'+escapeHtml(item.name)+'</strong><span>'+escapeHtml(item.isDefault?'Domyślna wędzarnia':'Wędzarnia')+'</span></div><div class="actions">'+
      (item.isDefault?'':button({label:'Ustaw jako domyślną',variant:'secondary',attributes:{'data-smokehouse-default-smoker':item.id}}))+
      button({label:'Edytuj',variant:'ghost',attributes:{'data-smokehouse-edit-smoker':item.id}})+
      button({label:'Usuń',variant:'danger',attributes:{'data-smokehouse-archive-smoker':item.id}})+
    '</div></article>'
  ).join('')+'</div>';
}

function thermometerRows(model){
  const items=model?.thermometers?.items||[];
  if(!items.length)return emptyCopy('Nie masz jeszcze dodanego termometru.');
  return '<div class="manage-list">'+items.map(item=>{
    const details=item.channelCount?item.channelCount+' kanałów':'Liczba kanałów nieustawiona';
    return '<article class="manage-row"><div><strong>'+escapeHtml(item.name)+'</strong><span>'+escapeHtml(details)+'</span></div><div class="actions">'+
      button({label:'Edytuj',variant:'ghost',attributes:{'data-smokehouse-edit-thermometer':item.id}})+
    '</div></article>';
  }).join('')+'</div>';
}

function woodRows(model){
  const items=model?.wood?.items||[];
  if(!items.length)return emptyCopy('Nie masz jeszcze zapisanego drewna.');
  return '<div class="manage-list">'+items.map(item=>{
    const details=item.quantity!=null&&item.quantityUnit
      ?item.quantity+' '+item.quantityUnit
      :'Ilość nieustawiona';
    return '<article class="manage-row"><div><strong>'+escapeHtml(item.label)+'</strong><span>'+escapeHtml(details)+'</span></div><div class="actions">'+
      button({label:'Edytuj',variant:'ghost',attributes:{'data-smokehouse-edit-wood':item.id}})+
    '</div></article>';
  }).join('')+'</div>';
}

export function smokehouseManagementMarkup(kind,model){
  if(!model||typeof model!=='object')throw new TypeError('Smokehouse dashboard model is required');

  if(kind==='smokers'){
    return '<section class="manage-surface"><header class="manage-header"><div><span class="eyebrow">Moja wędzarnia</span><h2>Wędzarnie</h2><p>Zmieniaj konfigurację i wybierz sprzęt domyślny używany przez kolejne moduły.</p></div>'+button({id:'smokehouse-add-smoker',label:'Dodaj wędzarnię'})+'</header>'+smokerRows(model)+'<div class="actions">'+backAction()+'</div></section>';
  }

  if(kind==='thermometers'){
    return '<section class="manage-surface"><header class="manage-header"><div><span class="eyebrow">Moja wędzarnia</span><h2>Termometry</h2><p>Zarządzaj termometrami i liczbą dostępnych kanałów pomiarowych.</p></div>'+button({id:'smokehouse-add-thermometer',label:'Dodaj termometr'})+'</header>'+thermometerRows(model)+'<div class="actions">'+backAction()+'</div></section>';
  }

  if(kind==='wood'){
    return '<section class="manage-surface"><header class="manage-header"><div><span class="eyebrow">Moja wędzarnia</span><h2>Drewno</h2><p>Aktualizuj rodzaje drewna i ilości dostępne do kolejnych wędzeń.</p></div>'+button({id:'smokehouse-add-wood',label:'Dodaj drewno'})+'</header>'+woodRows(model)+'<div class="actions">'+backAction()+'</div></section>';
  }

  throw new TypeError('Unsupported Smokehouse management kind');
}
